import { render } from "./APAnimal.vue?vue&type=template&id=004ff260&scoped=true"
import script from "./APAnimal.vue?vue&type=script&lang=js"
export * from "./APAnimal.vue?vue&type=script&lang=js"

import "./APAnimal.vue?vue&type=style&index=0&id=004ff260&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-004ff260"]])

export default __exports__